import { Slot } from "radix-ui";
import type { ComponentProps } from "react";
import { cn } from "../../lib/utils";
export function Badge({
  variant = "secondary",
  asChild = false,
  className,
  ...props
}: ComponentProps<"span"> & {
  asChild?: boolean;
  variant?: "default" | "secondary" | "outline" | "destructive";
}) {
  const Tag = asChild ? Slot.Root : "span";
  return (
    <Tag
      {...props}
      data-slot="badge"
      className={cn("cyra-badge", variant === "destructive" && "text-destructive", className)}
    />
  );
}
